if (!customElements.get('why-feels-tabs')) {
  class WhyFeelsTabs extends HTMLElement {
    static MOBILE_QUERY = '(max-width: 767px)';

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-why-feels-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-why-feels-panel]'));
      this.mobileQuery = window.matchMedia(WhyFeelsTabs.MOBILE_QUERY);

      this.onTabClick = this.onTabClick.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));
      this.mobileQuery.addEventListener('change', this.onMediaChange);

      this.syncView();
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
      this.mobileQuery.removeEventListener('change', this.onMediaChange);
    }

    onTabClick(event) {
      if (this.mobileQuery.matches) return;
      this.setActiveTab(event.currentTarget);
    }

    onMediaChange() {
      this.syncView();
    }

    syncView() {
      if (this.mobileQuery.matches) {
        this.clearDesktopState();
        return;
      }

      const activeTab =
        this.tabs.find((tab) => tab.classList.contains('why-feels-tabs__tab--active')) || this.tabs[0];

      if (activeTab) {
        this.setActiveTab(activeTab);
      }
    }

    setActiveTab(tab) {
      const panelId = tab.getAttribute('aria-controls');
      if (!panelId) return;

      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('why-feels-tabs__tab--active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === panelId;
        panel.classList.toggle('why-feels-tabs__panel--active', isActive);
        panel.hidden = !isActive;
      });
    }

    clearDesktopState() {
      this.tabs.forEach((tab) => {
        tab.classList.remove('why-feels-tabs__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });

      this.panels.forEach((panel) => {
        panel.classList.remove('why-feels-tabs__panel--active');
        panel.hidden = false;
      });
    }
  }

  customElements.define('why-feels-tabs', WhyFeelsTabs);
}
